import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {MouseWheelDirective} from './../../../shared/directives/mouse-wheel-directive.directive';
@Component({
  selector: 'app-html-scroll-wheel',
  templateUrl: './html-scroll-wheel.component.html',
  styleUrls: ['./html-scroll-wheel.component.scss']
})
export class HtmlScrollWheelComponent implements OnInit {

  public _ScrollCount = 0;
  constructor() { }

  ngOnInit() {
  }

  mouseWheelUpFunc(event:any) {
    this._ScrollCount--;
  }
  
  mouseWheelDownFunc(event:any) {
    this._ScrollCount++;
  }
}
